import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "本周新番", to: "/series" },
  { label: "追番日历", to: "/calendar" },
  { label: "关于我们", to: "/about" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/series?q=${encodeURIComponent(q)}` : "/series");
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/90 backdrop-blur border-b border-background-200">
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-goblet-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl text-foreground-950">
            妖精动漫网
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden items-center gap-2 md:flex">
          <form
            onSubmit={handleSearch}
            className="flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5"
          >
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索动漫..."
              className="w-32 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              aria-label="搜索动漫"
            />
          </form>
          <Link
            to="/series"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始追番
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
          aria-label="打开菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-4 py-2.5 text-sm font-medium ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <form onSubmit={handleSearch} className="mt-2 flex items-center gap-2">
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索动漫..."
                className="w-full rounded-full border border-background-200 bg-background-100 px-4 py-2.5 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
                aria-label="搜索动漫"
              />
              <button
                type="submit"
                className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50"
              >
                搜索
              </button>
            </form>
          </div>
        </div>
      )}
    </header>
  );
}